import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { CustomerShip } from '../../types/CustomerShip';
import { DataFetchError } from '../../utils/ErrorClass';

export const useCustomerShips = () => {
  const [customerShips, setCustomerShips] = useState<CustomerShip[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const itemsPerPage = 100;

  const fetchCustomerShips = useCallback(async (page: number, query: string = '') => {
    try {
      const { data, error: dataError } = await supabase
        .rpc('get_customer_ships', {
          search_query: query,
          page: page,
          items_per_page: itemsPerPage
      });

      if (dataError) {
        throw new DataFetchError("データの取得失敗: " + dataError.message);
      }

      setCustomerShips(data as CustomerShip[]);
      setTotalPages(Math.ceil((data[0]?.total_count || 0) / itemsPerPage));
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    }
  }, [itemsPerPage]);

  useEffect(() => {
    fetchCustomerShips(page, searchQuery);
  }, [page, searchQuery, fetchCustomerShips]);

  return { customerShips, page, totalPages, setPage, setSearchQuery, error };
};
